import { Spin } from 'antd';

function Loader() {
  return (
    <div className="container-top-centered">
      <Spin />
    </div>
  );
}

export default Loader;
